import anastasiaKapchenova from '../images/sell-with-us/reviews/anastasia-kapchenova.png';
import anastasiaKapchenovaPhoto from '../images/sell-with-us/reviews/anastasia-kapchenova-photo.jpg';
import simonSimon from '../images/sell-with-us/reviews/simon-simon.png';
import annaKapchenova from '../images/sell-with-us/reviews/anna-kapchenova.png';
import benjaminZw from '../images/sell-with-us/reviews/benjamin-zw.png';
import temaDobry from '../images/sell-with-us/reviews/tema-dobry.png';
import danielSalimov from '../images/sell-with-us/reviews/daniel-salimov.png';
import grishaKhaspekyan from '../images/sell-with-us/reviews/grisha-khaspekyan.png';
import grishaKhaspekyanPhoto from '../images/sell-with-us/reviews/grisha-khaspekyan-photo.jpg';
import ivanRumyantsev from '../images/sell-with-us/reviews/ivan-rumyantsev.png';
import vartanMirakyan from '../images/sell-with-us/reviews/vartan-mirakyan.png';
import stephanieT from '../images/sell-with-us/reviews/stephanie-t.png';

export const REVIEWS = [
  {
    name: 'Anastasia Kapchenova',
    avatar: anastasiaKapchenova,
    caption: 'Satisfied Customer',
    headline: 'TWO WATCHES, TOTAL SATISFACTION',
    text: `I got two watches from Sany Watches, one for me and one as a gift and I’m honestly so happy with them.

Mine goes with literally everything, and I’ve already gotten compliments. The one I gave as a gift was also a hit they loved it!

Thank you Sany Watches for the professional service and helping me find the watches I desire 🫶🏻

PS : The best and most expensive showroom I’ve seen in the UAE`,
    photo: [anastasiaKapchenovaPhoto],
    stars: 5,
  },
  {
    name: 'Simon Simon',
    avatar: simonSimon,
    caption: 'Happy Collector',
    headline: 'A FULL LUXURY EXPERIENCE',
    text: `Hands down one of the best watch-buying experiences I’ve ever had. Sany Watches isn’t just a place to buy a timepiece — it’s a full-on luxury experience.

From the moment I walked into the showroom, I was genuinely impressed. It’s sleek, modern, and has that high-end vibe that instantly makes you feel like you’re in the right place.

What stood out the most was the personal approach. They weren’t just trying to sell me something — they really took the time to understand what I was looking for and helped me find the perfect watch for my style and collection.

I walked out with a stunning piece I’m completely obsessed with, and I’ll 100% be recommending Sany Watches to friends and fellow collectors.`,
    stars: 5,
  },
  {
    name: 'Anna Kapchenova',
    avatar: annaKapchenova,
    caption: 'Delighted Customer',
    headline: 'FRIENDLY & PROFESSIONAL SERVICE',
    text: `Great experience buying my watch here. The team was friendly and professional. They helped me pick the perfect style without any pressure. Highly recommend!`,
    stars: 5,
  },
  {
    name: 'Benjamin zw',
    avatar: benjaminZw,
    caption: 'Pleased Customer',
    headline: 'BEST PRICES, FAST SERVICE',
    text: `I always get brand new watches from Sany at the most competitive prices. Fast service, great selection, and unbeatable value,highly recommend`,
    stars: 5,
  },
  {
    name: 'Tema Dobry',
    avatar: temaDobry,
    caption: 'Happy Customer',
    headline: 'RARE WATCHES & VIP EXPERIENCE',
    text: `This is the best place to buy watches! I got a very rare watch in 1 day (at a very good price), invited to the office, gave me a drink, offered a hookah. In general, I only go there for watches now. (In addition to watches, they also have Birkin bags and labubs and accessories!)`,
    stars: 5,
  },
  {
    name: 'Daniel Salimov',
    avatar: danielSalimov,
    caption: 'Pleased Buyer',
    headline: 'PROMPT HELP, GREAT INVENTORY',
    text: 'Great inventory of watches. Rafael assisted with all queries promptly. Would absolutely recommend.',
    stars: 5,
  },
  {
    name: 'Grisha Khaspekyan',
    avatar: grishaKhaspekyan,
    caption: 'Satisfied Customer',
    headline: 'GUIDED TO THE PERFECT WATCH',
    text: `Thank you Rafael for guiding me to get the watch I really wanted, the showroom is absolutely stunning and the service is top notch, thank you Rafael & Sany Watches!`,
    photo: [grishaKhaspekyanPhoto],
    stars: 5,
  },
  {
    name: 'Ivan Rumyantsev',
    avatar: ivanRumyantsev,
    caption: 'Satisfied Buyer',
    headline: 'BEST PRICE ON THE MARKET',
    text: 'The most unique offers and objectively the best price on the market. Many thanks Rafael and team!',
    stars: 5,
  },
  {
    name: 'Vartan Mirakyan',
    avatar: vartanMirakyan,
    caption: 'Happy Customer',
    headline: 'SERVICE & QUALITY ON TOP',
    text: `Best one to do it!
Service and quality on the top Level`,
    stars: 5,
  },
  {
    name: 'Stephanie T',
    avatar: stephanieT,
    caption: 'Delighted Buyer',
    headline: 'SHOWROOM BEYOND EXPECTATIONS',
    text: `The most beautiful and best showroom in the UAE!!🤩🤩
It was so hard to choose because everything is so WOWWWWWW!!
Such a good experience!
Thank you so so much i recommend everyone who wants the best for the best price ever!
See you soon again!!!❤️❤️❤️`,
    stars: 5,
  },
];
